import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react-hooks/exhaustive-deps */
import { Icon } from '@livable/saas-react-components';
import { Button, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { PortfoliosSmartNav } from './PortfoliosSmartNav';
import { useStore } from 'src/stores';
import { ManageAccessModal } from 'src/components/shared/ManageAccessModal';
import { PropertiesTable } from './PropertiesTable';
import usePropertiesStyles from './styles';
import { EnrollmentModal } from 'src/components/resident/EnrollmentModal';
import { PropertyActionsMenu } from 'src/components/shared/PropertyActionsMenu';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { UpdateUtilityCredentialsBatchModal } from 'src/components/shared/UpdateUtilityCredentialsBatchModal';
export const PropertiesPage = observer(() => {
  const classes = usePropertiesStyles();
  const store = useStore();
  const history = useLocation();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showEnrollModal = _useState2[0],
    setShowEnrollModal = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showEnrollModalSelectedPropertyId = _useState4[0],
    setShowEnrollModalSelectedPropertyId = _useState4[1];
  let handleShowEnrollModal = val => {
    setShowEnrollModal(val);
  };
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showManageAccessModal = _useState6[0],
    setShowManageAccessModal = _useState6[1];
  const _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    propsPropertyDataManageAccessModal = _useState8[0],
    setPropsPropertyDataManageAccessModal = _useState8[1];
  const _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    propsPortfolioDataManageAccessModal = _useState0[0],
    setPropsPortfolioDataManageAccessModal = _useState0[1];
  const handleShowManageAccessModal = function (val) {
    let propertyData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    let portfolioData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    setShowManageAccessModal(val);
    setPropsPropertyDataManageAccessModal(propertyData);
    setPropsPortfolioDataManageAccessModal(portfolioData);
  };
  const _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    showAutoBillingBatchModalModal = _useState10[0],
    setShowAutoBillingBatchModalModal = _useState10[1];
  const handleShowAutoBillingBatchModalModal = function (val) {
    let propertyData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    let portfolioData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    console.log('handleShowAutoBillingBatchModalModal', propertyData, portfolioData);
    setShowAutoBillingBatchModalModal(val);
    setPropsPropertyDataManageAccessModal(propertyData);
    // setPropsPortfolioDataManageAccessModal(portfolioData);
  };
  const params = new URLSearchParams(history.search);
  const propertyId = params.get('id');
  const _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isLoading = _useState12[0],
    setIsLoading = _useState12[1];
  const _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    portfoliosData = _useState14[0],
    setPortfoliosData = _useState14[1];
  const selectAllPortfoliosKey = 'all-portfolios';
  const _useState15 = useState(selectAllPortfoliosKey),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedPortfolioId = _useState16[0],
    setSelectedPortfolioId = _useState16[1];
  const getPortfoliosList = () => {
    return portfoliosData.map(portfolio => {
      return {
        id: portfolio.id,
        name: portfolio.name,
        properties: portfolio.properties
      };
    });
  };
  const getSelectedPorfolioData = portfolioId => {
    return portfoliosData.find(item => item.id === portfolioId);
  };
  const getSelectedPortfolioProperties = portfolioId => {
    var _result$properties;
    if (selectedPortfolioId === selectAllPortfoliosKey) {
      return portfoliosData.map(portfolio => portfolio.properties.map(prop => {
        return _objectSpread(_objectSpread({}, prop), {}, {
          portfolio: {
            id: portfolio.id,
            name: portfolio.name,
            accessResponses: portfolio.accessResponses
          }
        });
      })).flat();
    }
    const result = portfoliosData === null || portfoliosData === void 0 ? void 0 : portfoliosData.find(item => item.id === portfolioId);
    return (result === null || result === void 0 || (_result$properties = result.properties) === null || _result$properties === void 0 ? void 0 : _result$properties.map(i => {
      return _objectSpread(_objectSpread({}, i), {}, {
        portfolio: {
          id: result.id,
          name: result.name,
          accessResponses: result.accessResponses
        }
      });
    })) || [];
  };
  const fetchPortfoliosData = async () => {
    const resp = await store.portfolios.getPortfoliosDashboardAsync.run();
    if (resp !== null && resp !== void 0 && resp.isSuccessful) {
      setPortfoliosData(resp === null || resp === void 0 ? void 0 : resp.response.portfolios);
      setSelectedPortfolioId(selectAllPortfoliosKey);
    }
  };
  const _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    enrolModalConfigEnablePropertySelect = _useState18[0],
    setEnrolModalConfigEnablePropertySelect = _useState18[1];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    enrolModalConfigEnableMultiAccount = _useState20[0],
    setEnrolModalConfigEnableMultiAccount = _useState20[1];
  const handleEnrolModalConfig = configType => {
    if (configType === 'PortfolioActionsMenu') {
      setEnrolModalConfigEnablePropertySelect(true);
      setEnrolModalConfigEnableMultiAccount(true);
    }
    if (configType === 'PropertiesTable') {
      setEnrolModalConfigEnablePropertySelect(false);
      setEnrolModalConfigEnableMultiAccount(false);
    }
  };
  const fetchData = async () => {
    setIsLoading(true);
    await store.allocations.getCurrentCycleAsync.run({
      companyId: localStorage.getItem(USER_SETTINGS_KEYS.company)
    });
    await fetchPortfoliosData();
    setIsLoading(false);
  };
  useEffect(() => {
    fetchData();
    store.portfoliosMultiActionStore.deselectAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.propertyPage
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.propertyPageContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.property
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.propertyTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2"
  }, "Properties"), /*#__PURE__*/React.createElement("div", {
    className: classes.actionButtons
  }, /*#__PURE__*/React.createElement(EnrollmentModal, {
    enablePropertySelect: true,
    enablePortfolioSelect: true,
    trigger: /*#__PURE__*/React.createElement(Button, {
      size: "large",
      variant: "actionIcon",
      className: classes.actionButtonsItem,
      'custom-attribute': '734-properties-page'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "move-in"
    }), t('portfolios_properties_page.enroll_resident'))
  }), /*#__PURE__*/React.createElement(Button, {
    component: RouterLink,
    id: "addNewProperty",
    to: "/new_property",
    size: "large",
    variant: "priority",
    className: classes.actionButtonsItem,
    'custom-attribute': '735-properties-page'
  }, t('portfolios_properties_page.add_new_property')), ' ', /*#__PURE__*/React.createElement(PropertyActionsMenu, {
    menuTriggerExternal: /*#__PURE__*/React.createElement(Icon, {
      type: "dotdotdot"
    }),
    handleShowEnrollModal: value => {
      handleEnrolModalConfig('PortfolioActionsMenu');
      setShowEnrollModal(value);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.propertyContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.propertyNav
  }, /*#__PURE__*/React.createElement(PortfoliosSmartNav, {
    name: "Portfolios",
    isIcon: true,
    isFilter: false,
    title: "Portfolio name 1",
    isLoadingExt: isLoading,
    portfoliosList: getPortfoliosList(),
    selectedPortfolio: selectedPortfolioId,
    setSelectedPortfolio: id => setSelectedPortfolioId(id),
    propertiesList: getSelectedPortfolioProperties(selectedPortfolioId),
    selectAllPortfoliosKey: selectAllPortfoliosKey,
    triggerRefresh: fetchData
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.propertyBody
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.propertyBodyContent
  }, /*#__PURE__*/React.createElement(PropertiesTable, {
    isSelectAllPropertiesEnabled: selectedPortfolioId === selectAllPortfoliosKey,
    selectAllPortfoliosKey: selectAllPortfoliosKey,
    selectedPortfolio: getSelectedPorfolioData(selectedPortfolioId),
    propertiesList: getSelectedPortfolioProperties(selectedPortfolioId),
    activeResidency: store.buildings.getBuilding.buildingAddress,
    buildingId: store.buildings.getBuilding.id,
    propertyId: propertyId,
    isLoadingExt: isLoading,
    triggerRefresh: fetchData,
    handleShowEnrollModal: value => {
      handleEnrolModalConfig('PropertiesTable');
      setShowEnrollModal(value);
    },
    setShowEnrollModalSelectedPropertyId: setShowEnrollModalSelectedPropertyId,
    handleShowManageAccessModal: handleShowManageAccessModal,
    handleShowAutoBillingBatchModalModal: handleShowAutoBillingBatchModalModal
  })))))), /*#__PURE__*/React.createElement(EnrollmentModal, {
    key: 'general-portfolio-enroll-modal',
    enablePropertySelect: enrolModalConfigEnablePropertySelect,
    showCurrentEnrollModal: showEnrollModal,
    handleShowCurrentEnrollModal: handleShowEnrollModal,
    portfolioId: selectedPortfolioId !== selectAllPortfoliosKey ? selectedPortfolioId : undefined,
    propertyId: showEnrollModalSelectedPropertyId,
    enablePortfolioSelect: true,
    trigger: null
  }), /*#__PURE__*/React.createElement(ManageAccessModal, {
    isEditMode: false,
    customTrigger: null,
    showModal: showManageAccessModal,
    handleShowModal: handleShowManageAccessModal,
    triggerRefresh: fetchData,
    propertyData: propsPropertyDataManageAccessModal,
    portfolioData: propsPortfolioDataManageAccessModal
  }), /*#__PURE__*/React.createElement(UpdateUtilityCredentialsBatchModal, {
    customTrigger: null,
    showModal: showAutoBillingBatchModalModal,
    handleShowModal: handleShowAutoBillingBatchModalModal,
    propertyData: propsPropertyDataManageAccessModal,
    portfolioData: propsPortfolioDataManageAccessModal
  }));
});